<template>
	<div class="pages">
		<div class="flexbox">
			<img  src='../../assets/face.png' />
		</div>
		<div style="margin-top: 10%;text-align: center;">
			<div class="submittext">{{'签约完成'}}</div>
		</div>
		<button class="button" @click="returnBack">返回</button>
	</div>
</template>
<script type="text/javascript" src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js"></script>
<script type="text/javascript">
	import wx from 'weixin-js-sdk';
	var ua = navigator.userAgent.toLowerCase();
	// import { Toast } from 'vant';
	export default {
		data() {
			return {
				faceShow: false,
				mid: '',
				urlStatus: ''
			};
		},
		created() {


		},
		mounted() {
			var url = window.location.href; //获取地址栏路径
		},
		methods: {
			returnBack() {
				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					//ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
					wx.miniProgram.getEnv((res) => {
						if (res.miniprogram) {
							wx.miniProgram.reLaunch({
								url: `/pagesA/device?isTrue=${true}`,
								success: (res) => {

								}
							})

						} else {
							wx.miniProgram.reLaunch({
								url: `/pagesA/device?isTrue=${true}`,
								success: (res) => {

								}
							})
						}
					})
				} else {
					wx.miniProgram.reLaunch({
						url: `/pagesA/device?isTrue=${true}`,
						success: (res) => {

						}
					})
				}
			}
		}
	};
</script>
<style lang="scss">
	.pages {
		height: 100%;
		width: 100%;
		flex-wrap: nowrap;
		overflow: hidden;
	}

	.flexbox {
		width: 100%;
		height: 100px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 10%;

		img {
			width: 80px;
			align-items: center;
			justify-content: center;
			margin-top: 20%;
		}
	}

	.submittext {
		font-size: 16px;
		font-weight: bold;
	}

	.riytext {
		font-size: 12px;
		font-weight: 400;
		color: #757880;
		margin-top: 1%;
	}

	.button {
		width: 95%;
		color: #fff;
		height: 45px;
		margin-left: 2.5%;
		margin-top: 15%;
		background: #E73A36;
		border-radius: 28px;
		opacity: 1;
		font-size: 18px;
		line-height: 45px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: 500;
		border: 0;
	}
</style>
